import React, { useState, useEffect } from "react";
import CapacityHero from "./CapacityHero";
import CapacityIntro from "./CapacityIntro";
import CapacityHighlights from "./CapacityHighlights";
import ProgramDuration from "./ProgramDuration";
import WhyJoin from "./WhyJoin";


export default function Home() {

  return (
    <div>
<CapacityHero />
<CapacityIntro />
<CapacityHighlights />
<ProgramDuration />
<WhyJoin />
    </div>
  );
}
